var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 pb-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }